export const API_HOST = process.env.NODE_ENV !== 'development' ? window.location.origin : 'https://auth.pga.local:4443'
export const AWS_REGION = process.env.REACT_APP_AWS_REGION || 'us-east-1'
export const COGNITO_PUBLIC_CLIENT_ID = process.env.REACT_APP_COGNITO_PUBLIC_CLIENT_ID || '1eeeb37prdo2ep3ri7vv6pun75'
